import posthog from 'posthog-js'

const token = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN
const host = import.meta.env.VITE_PUBLIC_POSTHOG_HOST
const environment =
  import.meta.env.VITE_PUBLIC_POSTHOG_ENVIRONMENT ?? import.meta.env.MODE

if (token && host) {
  posthog.init(token, {
    api_host: host,
    capture_pageview: false,
    autocapture: false,
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
    },
    debug: import.meta.env.DEV,
  })
  posthog.register({ environment })
}

export { posthog }
